import i18next from "i18next";
import * as sup from "superstruct";

import { markQueryErrorHandled, notifyBugsnag } from "@/logging";
import { notify } from "@/modules/notify/notify";

export const basicErrorResponseValidator = sup.type({
  response: sup.type({
    data: sup.object({
      errors: sup.array(
        sup.type({
          code: sup.string(),
        })
      ),
    }),
    status: sup.integer(),
  }),
});
type ApiError = sup.Infer<typeof basicErrorResponseValidator>;

const translationNamespace = "apiMessages/defaults";
const t = i18next.getFixedT(null, translationNamespace);

export const apiErrorValidate = (
  error: unknown,
  translations?: {
    [x: number]: Record<string, string>;
  }
) => {
  const [validationError, apiError] = sup.validate(
    error,
    basicErrorResponseValidator
  );

  if (!validationError && apiError) {
    const status = getApiErrorStatus(apiError);
    const errorCode = getApiErrorCode(apiError);
    const translation = findApiErrorTranslation({
      status,
      errorCode,
      translations,
    });

    if (translation) {
      markQueryErrorHandled(error);
      notify.alert.error(translation);
      return;
    } else {
      const noTranslationError = new Error(
        `No key: ${errorCode} in translations at the ${status}`
      );

      // eslint-disable-next-line no-console
      console.error(noTranslationError);
      notifyBugsnag(noTranslationError);
    }
  }

  notify.alert.error(t("Something went wrong, try again later"));
};

function getApiErrorStatus(apiError: ApiError) {
  return apiError.response.status;
}

function getApiErrorCode(apiError: ApiError) {
  return apiError.response.data.errors[0]?.code;
}

function findApiErrorTranslation({
  status,
  errorCode,
  translations = {},
}: {
  status: number;
  errorCode: string;
  translations?: {
    [x: number]: Record<string, string>;
  };
}) {
  if (translations[status]?.[errorCode]) {
    return translations[status][errorCode];
  }

  if (i18next.exists(errorCode, { ns: translationNamespace })) {
    return t(errorCode);
  }

  return undefined;
}
